import type { RecordJobData } from "@smartsuite/automation-engine-api";
import { ActionLabel } from "../../../../../utils/constants";
import { AILoopingActionResultGroup } from "./components/AILoopingActionResultGroup/AILoopingActionResultGroup";
import { DeleteLoopingRecordsGroup } from "./components/DeleteLoopingRecordsGroup/DeleteLoopingRecordsGroup";
import { GenerateLoopingPdfGroup } from "./components/GenerateLoopingPdfGroup/GenerateLoopingPdfGroup";
import type { ActionWithDetails } from "./types";
import type { ReactElement } from "react";
import { GeneralLoopingActionResultGroup } from "./components/GeneralLoopingActionResultGroup/GeneralLoopingActionResultGroup";
import { GenerateLoopingWebhookGroup } from "./components/GenerateLoopingWebhookGroup/GenerateLoopingWebhookGroup";
import { FindLoopingRecordsGroup } from "./components/FindLoopingRecordsGroup/FindLoopingRecordsGroup";
import { DocsAutomatorLoopingGroup } from "./components/DocsAutomatorLoopingGroup";
import {
  getMsTeamsActionableNotificationInputValue,
  MS_TEAMS_SEND_ACTIONABLE_NOTIFICATION_ACTION_ID,
} from "../MsTeamsActionableNotificationGroup/get-input-value";
interface ActionRendererProps {
  actionWithDetails: ActionWithDetails;
  recordJobData?: RecordJobData;
  recordJobDataByDetailsId: Record<string, RecordJobData>;
  onDetailsClick: () => void;
  onHeaderClick: (recordJobId: string) => void;
}

const ActionComponents = {
  [ActionLabel.findRecords]: FindLoopingRecordsGroup,
  [ActionLabel.deleteRecord]: DeleteLoopingRecordsGroup,
  [ActionLabel.generatePdf]: GenerateLoopingPdfGroup,
  [ActionLabel.sendWebhook]: GenerateLoopingWebhookGroup,
  [ActionLabel.docsautomator]: DocsAutomatorLoopingGroup,
  [ActionLabel.ai]: AILoopingActionResultGroup,
};

export const ActionRenderer = ({
  actionWithDetails,
  recordJobData,
  recordJobDataByDetailsId,
  onDetailsClick,
  onHeaderClick,
}: ActionRendererProps): ReactElement | null => {
  const { action, recordJobIds } = actionWithDetails;

  if (!action.actionReference) {
    return null;
  }

  const actionId = action.actionReference.actionId;
  if (!actionId) return null;

  const ActionComponent =
    ActionComponents[actionId as keyof typeof ActionComponents];

  if (ActionComponent) {
    return (
      <ActionComponent
        key={actionId}
        action={action}
        recordJobDataByDetailsId={recordJobDataByDetailsId}
        recordJobData={recordJobData}
        recordJobIds={recordJobIds}
        onDetailsClick={onDetailsClick}
        onRecordClick={onHeaderClick}
      />
    );
  }

  return (
    <GeneralLoopingActionResultGroup
      key={actionId}
      action={action}
      recordJobDataByDetailsId={recordJobDataByDetailsId}
      recordJobData={recordJobData}
      recordJobIds={recordJobIds}
      onDetailsClick={onDetailsClick}
      onRecordClick={onHeaderClick}
      getInputValue={
        actionId === MS_TEAMS_SEND_ACTIONABLE_NOTIFICATION_ACTION_ID
          ? getMsTeamsActionableNotificationInputValue
          : undefined
      }
    />
  );
};
